import { Component } from "@angular/core";

@Component({
  standalone: false,
    selector: "products-access-denied",
    templateUrl: "./access-denied.component.html",
    styleUrls: ["./access-denied.component.scss"],
  })
  export class AccessDeniedComponent {

  }